var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity main"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"case"}),_c('img',{staticClass:"code code-an",attrs:{"src":"https://image.xiaoxxx.cn/test/urlGather/202407165bc52f1bb711e5ca591300.png","alt":""}})])])
}]

export { render, staticRenderFns }